import { OverlayTrigger as BootstrapOverlayTrigger } from 'react-bootstrap';
import { type OverlayTriggerProps } from 'react-bootstrap';

const OverlayTrigger = ({ placement = 'bottom', ...props }: OverlayTriggerProps) => (
  <BootstrapOverlayTrigger {...props} placement={placement} />
);

OverlayTrigger.Popover = ({
  containerPadding = 20,
  popperConfig = {
    modifiers: [
      {
        name: 'offset',
        options: {
          offset: [0, 10],
        },
      },
    ],
  },
  trigger = 'click',
  ...props
}: OverlayTriggerProps) => (
  <OverlayTrigger
    containerPadding={containerPadding}
    popperConfig={popperConfig}
    rootClose
    trigger={trigger}
    {...props}
  />
);

OverlayTrigger.Tooltip = ({ trigger = ['focus', 'hover'], ...props }: OverlayTriggerProps) => (
  <OverlayTrigger {...props} trigger={trigger} />
);

export default OverlayTrigger;
